'use strict'

const htmlElement = document.querySelector('.subtitle')
const getValueFromElement = () => htmlElement.innerText
const setValueToElement = (value) => {
  htmlElement.innerHTML = value
}

let queue = []
let frame = 0
let counter = 0
let frameRequestId

const phrases = [
  'Software developer',
  'DevOps engineer',
  'Cloud engineer',
  'Serverless developer',
  'Full Stack Developer',
]

const update = () => {
  let output = ''
  let complete = 0

  for (let i = 0, n = queue.length; i < n; i++) {
    let { from, to, start, end, char } = queue[i]
    if (frame >= end) {
      complete++
      output += to
    } else if (frame >= start) {
      if (!char || Math.random() < 0.28) {
        char = randomChar()
        queue[i].char = char
      }
      output += `<span class="dud">${char}</span>`
    } else {
      output += from
    }
  }

  setValueToElement(output)
  if (complete === queue.length) {
    setTimeout(textScramble, 800)
  } else {
    frameRequestId = requestAnimationFrame(update)
    frame++
  }
}

const randomChar = () => {
  const chars =
    'abcdefghijklmnopqrstuvwxyz0123456789!<>-_\\/[]{}—=+*^?#________'
  return chars[Math.floor(Math.random() * chars.length)]
}

const setText = (newText) => {
  const oldText = getValueFromElement()
  const length = Math.max(oldText.length, newText.length)
  queue = []

  for (let i = 0; i < length; i++) {
    const from = oldText[i] || ''
    const to = newText[i] || ''
    const start = Math.floor(Math.random() * 40)
    const end = start + Math.floor(Math.random() * 40)
    queue.push({ from, to, start, end })
  }

  cancelAnimationFrame(frameRequestId)
  frame = 0
  update()
}

const textScramble = () => {
  setText(phrases[counter])
  counter++
  if (counter >= phrases.length) counter = 0
}

textScramble()
